import ProductTempleteAmpturn from "../templates/product-templete-large";
import { LTTape } from '../data/products'

function ProductAmpturnTape() {
    return (
        <>
            <ProductTempleteAmpturn data = {LTTape}/>
        </>
    )
}

export default ProductAmpturnTape;